import { whatsappIntegrationDisplayLabel } from "@/lib/whatsapp-integration-label";
import type { CampaignIntegrationOption } from "@/lib/automation-campaign";

type IntegrationRow = {
  id: string;
  provider: string;
  config?: {
    display_name?: string | null;
    username?: string | null;
    page_name?: string | null;
    display_phone_number?: string | null;
    verified_name?: string | null;
    phone_number?: string | null;
  } | null;
  instance_identifier?: string | null;
};

export function mapIntegrationToCampaignOption(row: IntegrationRow): CampaignIntegrationOption {
  if (row.provider.startsWith("whatsapp")) {
    const display_name = whatsappIntegrationDisplayLabel(row);
    const cfg = row.config;
    const detail =
      (typeof cfg?.display_phone_number === "string" && cfg.display_phone_number.trim()) ||
      (typeof cfg?.phone_number === "string" && cfg.phone_number.trim()) ||
      undefined;
    return { id: row.id, provider: row.provider, display_name, detail };
  }

  const cfg = row.config;
  const display_name =
    (typeof cfg?.display_name === "string" && cfg.display_name.trim()) ||
    (typeof cfg?.username === "string" && cfg.username.trim()) ||
    (typeof cfg?.page_name === "string" && cfg.page_name.trim()) ||
    row.instance_identifier ||
    "Instagram";

  return {
    id: row.id,
    provider: row.provider,
    display_name,
    detail: typeof cfg?.username === "string" ? `@${cfg.username.replace(/^@/, "")}` : undefined,
  };
}
